import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { map, pluck } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import * as i1$1 from 'primeng/dynamicdialog';
import * as i3 from 'ngx-toastr';
import * as i4 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i5 from 'primeng/dropdown';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/button';
import * as i8 from 'primeng/inputtext';
import * as i9 from 'primeng/card';
import * as i10 from 'primeng/tooltip';
import * as i11 from 'primeng/radiobutton';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';

class JobDutiesLibraryService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getJobRoles(companyId) {
        return this.httpClient.get(`/company/${companyId}/masterData/jobRole`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getJobCategoryList_ddl() {
        return this.httpClient.get(`/company/masterData/jobcategory`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getJobRolesList_ddl(categoryId, selectedCompany) {
        return this.httpClient.get(`/company/${selectedCompany.companyId}/category/${categoryId}/jobroles`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    resetDefault(jobTitle) {
        return this.httpClient.get(`/company/${jobTitle}/reset/jobduties`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
}
JobDutiesLibraryService.ɵfac = function JobDutiesLibraryService_Factory(t) { return new (t || JobDutiesLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
JobDutiesLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: JobDutiesLibraryService, factory: JobDutiesLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDutiesLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function JobDutiesLibraryComponent_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function JobDutiesLibraryComponent_ng_template_23_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.saveJobRoleOrPopulateDuties(); });
    i0.ɵɵtext(1, " POPULATE DUTIES & SUB-DUTIES ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 24);
    i0.ɵɵelementStart(3, "h6", 25);
    i0.ɵɵtext(4, "OR");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.disabledControls || !ctx_r0.parentForm.get("jobRole").value ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx_r0.disabledControls || !ctx_r0.parentForm.get("jobRole").value);
} }
function JobDutiesLibraryComponent_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "label", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Specify ", ctx_r1.parentForm.get("jobRole").value, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("readonly", ctx_r1.disabledControls);
} }
function JobDutiesLibraryComponent_p_card_36_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtext(1, "Sub-Duty ");
    i0.ɵɵelementEnd();
} }
function JobDutiesLibraryComponent_p_card_36_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelementStart(1, "div", 43);
    i0.ɵɵelementStart(2, "div", 44);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 45);
    i0.ɵɵelementStart(5, "button", 46);
    i0.ɵɵlistener("click", function JobDutiesLibraryComponent_p_card_36_div_15_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r14); const subJobDutyIndex_r11 = ctx.index; const dutyIndex_r7 = i0.ɵɵnextContext().index; const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.subDutiesDelete(dutyIndex_r7, subJobDutyIndex_r11); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dutyDescription_r10 = ctx.$implicit;
    const subJobDutyIndex_r11 = ctx.index;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", subJobDutyIndex_r11);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", dutyDescription_r10.value.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r9.disabledControls);
} }
function JobDutiesLibraryComponent_p_card_36_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-card", 28);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelementStart(2, "div", 30);
    i0.ɵɵelementStart(3, "span", 31);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 32);
    i0.ɵɵelementStart(6, "div", 33);
    i0.ɵɵelementStart(7, "div", 34);
    i0.ɵɵtext(8, " Duty ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 35);
    i0.ɵɵelementStart(10, "button", 36);
    i0.ɵɵlistener("click", function JobDutiesLibraryComponent_p_card_36_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r16); const duty_r6 = ctx.$implicit; const dutyIndex_r7 = ctx.index; const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.dutiesDelete(duty_r6, dutyIndex_r7); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 37);
    i0.ɵɵlistener("click", function JobDutiesLibraryComponent_p_card_36_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r16); const duty_r6 = ctx.$implicit; const dutyIndex_r7 = ctx.index; const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.handleEdit(duty_r6, dutyIndex_r7); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 38);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, JobDutiesLibraryComponent_p_card_36_div_14_Template, 2, 0, "div", 39);
    i0.ɵɵtemplate(15, JobDutiesLibraryComponent_p_card_36_div_15_Template, 6, 3, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const duty_r6 = ctx.$implicit;
    const dutyIndex_r7 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", dutyIndex_r7);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(dutyIndex_r7 + 1);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", ctx_r2.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", duty_r6.value.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.getSubDutiesList(dutyIndex_r7).length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.getSubDutiesList(dutyIndex_r7));
} }
function JobDutiesLibraryComponent_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵelementStart(1, "div", 48);
    i0.ɵɵelement(2, "p-radioButton", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵelement(4, "p-radioButton", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", 1);
} }
const _c0 = function () { return { "width": "100%" }; };
const _c1 = function (a0) { return { "addBtn": a0 }; };
const _c2 = function (a0) { return { "disabled": a0 }; };
function AddDutyComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, " This Field is required ");
    i0.ɵɵelementEnd();
} }
function AddDutyComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "textarea", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subDutyIndex_r3 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formGroupName", subDutyIndex_r3);
} }
const _c3 = function (a0) { return { "btn-success_disabled": a0 }; };
class JobDutiesLibraryComponent {
    constructor(dialogService, apiService, toastr, jobDescriptionBuilder) {
        this.dialogService = dialogService;
        this.apiService = apiService;
        this.toastr = toastr;
        this.jobDescriptionBuilder = jobDescriptionBuilder;
        this.deleteDuty = new EventEmitter();
        this.deleteAllDutie = new EventEmitter();
        this.deleteSubDuty = new EventEmitter();
        this.addUpdateDuty = new EventEmitter();
        this.onsaveJobRoleOrPopulateDuties = new EventEmitter();
        this.observableSubscription$ = new Subject();
        this.categoryList = [];
        this.disabledControls = false;
        this.jobRoleOptions = [];
        // this.selectedJobPosition = null;
        this.otherJobPosition = null;
    }
    ngOnInit() {
        // this.loadCategory_ddl();
        // $('#btnRadio').prop("checked", true);
        // $("input:radio[value='0']").prop('checked',true);
    }
    ngOnChanges(changes) {
        if (this.parentForm) {
            // work around for primeng radio button
            this.parentForm.get('selectedRaiobtn').valueChanges.subscribe(e => {
                this.parentForm.get('selectedRaiobtn').setValue(e, { emitEvent: false });
            });
            this.loadCategory_ddl();
        }
    }
    // ==========================
    loadCategory_ddl() {
        this.apiService.getJobCategoryList_ddl().subscribe(res => {
            this.categoryList = res;
            //populate job category
            if (this.inputData && this.parentForm && this.inputData.jsonInput && this.inputData.jsonInput.jobCategory) {
                const selectedCategory = this.categoryList.filter((cat) => cat.jobCategory === this.inputData.jsonInput.jobCategory);
                if (selectedCategory.length) {
                    this.parentForm.get('selectedCategory').patchValue(selectedCategory[0]);
                    this.loadJobRoles_ddl({ value: { id: selectedCategory[0].id } });
                }
            }
        });
    }
    onChange_Category(event) {
        this.loadJobRoles_ddl(event);
    }
    loadJobRoles_ddl(event) {
        this.apiService.getJobRolesList_ddl(event.value.id, this.inputData).subscribe(response => {
            if (response) {
                this.jobRoleOptions = response.filter(role => role.jobTitle !== 'Other');
                // this.selectedJobPosition = this.parentForm.get('jobRole').value === 'Other' ? 'Other' : this.parentForm.get('jobRole').value;
                let selectedJobRole = [];
                if (this.inputData && this.parentForm && this.inputData.jsonInput && this.inputData.jsonInput.jobRole) {
                    selectedJobRole = this.jobRoleOptions.filter((role) => role.jobTitle === this.inputData.jsonInput.jobRole);
                }
                if (selectedJobRole.length) {
                    this.parentForm.get('jobRole').patchValue(selectedJobRole[0].jobTitle);
                }
                else {
                    this.parentForm.get('jobRole').patchValue(null);
                }
                // this.selectedJobPosition = null;
            }
        });
    }
    // getJobRoles() {
    //   this.apiService.getJobRoles(this.inputData.companyId).pipe(takeUntil(this.observableSubscription$))
    //     .subscribe((response: ImagilityBaseResponse) => {
    //       if (response) {
    //         this.jobRoleOptions = response.data;
    //         this.selectedJobPosition = this.parentForm.get('jobRole').value === 'Other' ? 'Other' : this.parentForm.get('jobRole').value;
    //       }
    //     });
    // }
    setPositionTitle({ value }) {
        sessionStorage.setItem('selectedJobRole', JSON.stringify(this.jobRoleOptions.find(item => item.jobTitle == value)));
        if (value !== 'Other') {
            this.parentForm.controls['otherJobPosition'].setValue(null);
        }
        // this.selectedJobPosition = value;
    }
    saveJobRoleOrPopulateDuties() {
        const jobRole = this.parentForm.get('jobRole').value;
        this.onsaveJobRoleOrPopulateDuties.emit({
            selectedJobPosition: jobRole,
            customPositionTitle: this.parentForm.get('otherJobPosition').value,
            selectedJobPositionId: this.jobRoleOptions.find(x => x.jobTitle === jobRole).id
        });
    }
    get dutyList() {
        return this.parentForm.controls['duties'].controls;
    }
    getSubDutiesList(dutyIndex) {
        return this.parentForm.controls['duties'].controls[dutyIndex].get('subJobDuty').controls;
    }
    addDuty(duty = null, type = 'ADD', dutyIndex = null) {
        this.dialogRef = this.dialogService.open(AddDutyComponent, {
            header: 'Add Duty and Sub-duties',
            data: {
                duties: {
                    name: duty && duty.name ? duty.name : '',
                    id: duty && duty.id ? duty.id : null,
                    subJobDuty: duty && duty.subJobDuty ? duty.subJobDuty : []
                },
                type,
                dutyIndex
            },
            width: '70%',
            contentStyle: { 'max-height': '500px', 'overflow': 'auto' },
            baseZIndex: 2000
        });
        this.dialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.addUpdateDuty.emit(response);
        });
    }
    deleteAllDuties() {
        this.deleteAllDutie.emit();
    }
    handleEdit(duty, dutyIndex) {
        this.addDuty(duty.value, 'UPDATE', dutyIndex);
    }
    dutiesDelete(duty, i) {
        this.deleteDuty.emit({ duty, dutyIndex: i });
    }
    subDutiesDelete(dutyIndex, subJobDutyIndex) {
        this.deleteSubDuty.emit({ dutyIndex, subJobDutyIndex });
    }
    // resetToDefault() {
    //   this.apiService.resetDefault(this.parentForm.get('jobRole').value).subscribe(res => {
    //     (this.parentForm.controls['duties'] as FormArray).clear();
    //     res['jobDuty'].forEach(element => {
    //       element['id'] = null;
    //       element.subduty.forEach(subJobDuty => {
    //         subJobDuty['id'] = null;
    //       });
    //       (this.parentForm.controls['duties'] as FormArray).push(this.buildDutyList(element));
    //     });
    //   });
    // }
    buildDutyList(item) {
        const subJobDuty = [];
        if (item.subduty && item.subduty.length > 0) {
            item.subduty.forEach(element => {
                subJobDuty.push(this.buildSubDutyList(element));
            });
        }
        else if (item.subJobDuty && item.subJobDuty.length > 0) {
            item.subJobDuty.forEach(element => {
                subJobDuty.push(this.buildSubDutyList(element));
            });
        }
        return this.jobDescriptionBuilder.group({
            id: item.id,
            name: item.duty || item.name,
            subJobDuty: this.jobDescriptionBuilder.array(subJobDuty)
        });
    }
    buildSubDutyList(item) {
        return this.jobDescriptionBuilder.group({
            id: item.id,
            name: item.duty || item.name
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
JobDutiesLibraryComponent.ɵfac = function JobDutiesLibraryComponent_Factory(t) { return new (t || JobDutiesLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.DialogService), i0.ɵɵdirectiveInject(JobDutiesLibraryService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.FormBuilder)); };
JobDutiesLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: JobDutiesLibraryComponent, selectors: [["job-duties-library"]], inputs: { parentForm: "parentForm", inputData: "inputData", disabledControls: "disabledControls" }, outputs: { deleteDuty: "deleteDuty", deleteAllDutie: "deleteAllDutie", deleteSubDuty: "deleteSubDuty", addUpdateDuty: "addUpdateDuty", onsaveJobRoleOrPopulateDuties: "onsaveJobRoleOrPopulateDuties" }, features: [i0.ɵɵNgOnChangesFeature], decls: 38, vars: 22, consts: [[3, "formGroup"], [1, "row", "col-md-12", "pt-4", "duties-header"], [1, "row"], [1, "col-md-6"], [1, "label-cls"], ["placeholder", "Select Category", "formControlName", "selectedCategory", "appendTo", "body", "optionLabel", "jobCategory", 3, "options", "disabled", "onChange"], [1, "col-md-6", "processing-dropdown"], ["id", "jobRolesId", "appendTo", "body", "optionLabel", "jobTitle", "optionValue", "jobTitle", "formControlName", "jobRole", "placeholder", "select", 3, "options", "filter", "disabled", "onChange"], [1, "row", "mt-2", "pt-2", "d-flex", "align-items-center", "duties-header"], [1, "col-md-12"], ["for", "pl-0", 1, "mb-0", "mt-3", "label-cls"], [3, "ngIf"], [1, "pull-left"], [3, "ngClass"], ["type", "button", "pButton", "", "label", "ENTER IT YOURSELF", 1, "btn", "p-button-primary", "addDutyBtn", 3, "disabled", "ngClass", "click"], [1, "row", "col-md-12", "mt-2", "pt-2", "d-flex", "align-items-center", "duties-header"], [1, "col-6", "p-0"], [1, "col-6"], [1, "pull-right", "d-flex"], ["type", "button", "pButton", "", "label", "Delete All Duties", "iconPos", "right", 1, "btn", "p-button-secondary", "delete-btn", "d-flex", "align-items-center", 3, "disabled", "click"], ["formArrayName", "duties", 1, "row", "mt-2", "mt-3"], ["class", "my-1 col-md-12 duty-card", 4, "ngFor", "ngForOf"], ["class", "row pb-5 mt-3", 4, "ngIf"], ["type", "button", "pButton", "", 1, "pull-left", 3, "ngClass", "disabled", "click"], [1, "pull-left", "duties-header"], [1, "line-height-same-as-btn", "mr-3"], [1, "pull-left", "mr-3"], ["id", "otherJobPosition", "formControlName", "otherJobPosition", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mask-in", "mw-100", 3, "readonly"], [1, "my-1", "col-md-12", "duty-card"], [1, "row", "mt-2", 3, "formGroupName"], [1, "col-md-1", "mt-3", "text-center"], [1, "duty-list"], [1, "col-md-11", "pl-0"], [1, "row", "col-md-12", "duty-title", "d-flex", "align-items-center"], [1, "col-md-10", "pr-0", "pl-0", "duty"], [1, "col-md-2", "pr-0", "pl-0"], ["type", "button", "pButton", "", "title", "Delete", "pTooltip", "Delete", "icon", "pi pi-trash", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"], ["type", "button", "pButton", "", "title", "Edit", "pTooltip", "Edit", "icon", "pi pi-pencil", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"], [1, "row", "col-md-12", "duty-txt"], ["class", "row col-md-12 duty-title subDuty", 4, "ngIf"], ["class", "row col-md-12 p-0", "formArrayName", "subJobDuty", 4, "ngFor", "ngForOf"], [1, "row", "col-md-12", "duty-title", "subDuty"], ["formArrayName", "subJobDuty", 1, "row", "col-md-12", "p-0"], [1, "row", "col-md-12", "duty-txt", 3, "formGroupName"], [1, "col-md-11", "p-0"], [1, "col-md-1", "p-0"], ["pButton", "", "type", "button", "title", "Delete", "pTooltip", "Delete", "icon", "pi pi-trash", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"], [1, "row", "pb-5", "mt-3"], [1, "col-md-12", "mb-1"], ["name", "selectedRaiobtn", "label", "Update data only for this petition", "formControlName", "selectedRaiobtn", 3, "value"], ["name", "selectedRaiobtn", "label", "Add/Update data in the master data", "formControlName", "selectedRaiobtn", 3, "value"]], template: function JobDutiesLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h5");
        i0.ɵɵtext(3, "List Of Duties");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "label", 4);
        i0.ɵɵtext(7, " Select the Job Category");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "p-dropdown", 5);
        i0.ɵɵlistener("onChange", function JobDutiesLibraryComponent_Template_p_dropdown_onChange_8_listener($event) { return ctx.onChange_Category($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 2);
        i0.ɵɵelementStart(10, "div", 6);
        i0.ɵɵelementStart(11, "label", 4);
        i0.ɵɵtext(12, " Select the Job Position");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "p-dropdown", 7);
        i0.ɵɵlistener("onChange", function JobDutiesLibraryComponent_Template_p_dropdown_onChange_13_listener($event) { return ctx.setPositionTitle($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 8);
        i0.ɵɵelementStart(15, "div", 9);
        i0.ɵɵelementStart(16, "label", 10);
        i0.ɵɵelementStart(17, "b");
        i0.ɵɵtext(18, "Note");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(19, " : ");
        i0.ɵɵelementStart(20, "span");
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 9);
        i0.ɵɵtemplate(23, JobDutiesLibraryComponent_ng_template_23_Template, 5, 2, "ng-template", 11);
        i0.ɵɵtemplate(24, JobDutiesLibraryComponent_ng_template_24_Template, 4, 2, "ng-template", 11);
        i0.ɵɵelementStart(25, "div", 12);
        i0.ɵɵelementStart(26, "div", 13);
        i0.ɵɵelementStart(27, "button", 14);
        i0.ɵɵlistener("click", function JobDutiesLibraryComponent_Template_button_click_27_listener() { return ctx.addDuty(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 15);
        i0.ɵɵelementStart(29, "div", 16);
        i0.ɵɵelementStart(30, "h5");
        i0.ɵɵtext(31, " Added Duties & Sub-duties");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 17);
        i0.ɵɵelementStart(33, "div", 18);
        i0.ɵɵelementStart(34, "button", 19);
        i0.ɵɵlistener("click", function JobDutiesLibraryComponent_Template_button_click_34_listener() { return ctx.deleteAllDuties(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 20);
        i0.ɵɵtemplate(36, JobDutiesLibraryComponent_p_card_36_Template, 16, 7, "p-card", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(37, JobDutiesLibraryComponent_div_37_Template, 5, 2, "div", 22);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.parentForm);
        i0.ɵɵadvance(8);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(17, _c0));
        i0.ɵɵproperty("options", ctx.categoryList)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("options", ctx.jobRoleOptions)("filter", false)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate1(" ", ctx.parentForm.get("jobRole").value === "Other" ? "Please specify the job position and enter it yourself" : "After selecting Job Position, Please click on the Populate Job Duties button to get the default List of Duties or enter it yourself", "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.parentForm.get("jobRole").value !== "Other");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.parentForm.get("jobRole").value === "Other");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c1, ctx.parentForm.get("jobRole").value === "Other"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.disabledControls)("ngClass", i0.ɵɵpureFunction1(20, _c2, ctx.disabledControls));
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.dutyList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.parentForm.get("jobRole").value && (ctx.parentForm.get("jobRole").value !== "Other" || ctx.parentForm.get("jobRole").value === "Other" && ctx.parentForm.get("otherJobPosition").value) && ctx.dutyList.length > 0);
    } }, directives: [i4.NgControlStatusGroup, i4.FormGroupDirective, i5.Dropdown, i4.NgControlStatus, i4.FormControlName, i6.NgIf, i6.NgClass, i7.ButtonDirective, i4.FormArrayName, i6.NgForOf, i4.DefaultValueAccessor, i8.InputText, i9.Card, i4.FormGroupName, i10.Tooltip, i11.RadioButton], styles: [".label-cls[_ngcontent-%COMP%]{color:#4a4a4a;font:normal normal normal 14px/20px Source Sans Pro}.readOnly-label[_ngcontent-%COMP%]{width:100%;font-size:16px;color:#4a4a4a;padding-top:3px;font-weight:500}.sub-title[_ngcontent-%COMP%]{color:#3d3d63;font-size:16px;font-weight:700}.duty-title[_ngcontent-%COMP%]{background-color:#eff5fe;padding:10px;border:1px solid #c3c3c3;margin-bottom:0;font-size:13px;font-weight:600}.duty-txt[_ngcontent-%COMP%]{border:1px solid #b0b0b0;padding:10px;font-size:14px}.delete-btn[_ngcontent-%COMP%]{display:inline-flex;padding:10px!important}.btn-outline-secondary[_ngcontent-%COMP%]{border:1px solid #19a0da!important;background:#fff;height:43px;color:#19a0da;text-transform:uppercase;padding:0 17px!important;font-size:18px!important}.btn-outline-secondary.disabled[_ngcontent-%COMP%], .btn-outline-secondary[_ngcontent-%COMP%]:disabled{opacity:.65!important;border-color:#6c757d!important;color:#6c757d;background-color:transparent}.duties-header[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#626262;font:normal normal 700 16px/25px Source Sans Pro}.duties-header[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:normal normal 600 16px/20px Source Sans Pro;color:#4d4f5c}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.mark-btn[_ngcontent-%COMP%]{background-color:#fff;color:#a2a2a2;font-size:14px;text-transform:uppercase;border:1px solid #a2a2a2;border-radius:8px}.btn-success[_ngcontent-%COMP%]{color:#fff!important;background-color:#19a0da!important;border-color:#19a0da!important}.duty[_ngcontent-%COMP%], .subDuty[_ngcontent-%COMP%]{font:normal normal normal 19px/27px Source Sans Pro!important;color:grey!important}.duty-txt[_ngcontent-%COMP%]{color:#626262!important;font:normal normal normal 16px/27px HelveticaNeue!important}.addDutyBtn[_ngcontent-%COMP%]{font:normal normal 700 14px/20px Source Sans Pro!important;color:#fff!important;text-transform:uppercase!important;background:#19a0da 0 0 no-repeat padding-box!important;border-radius:10px!important;width:194px!important}.delete-btn[_ngcontent-%COMP%]{background-color:#19a0da!important;border:none!important;color:#fff!important;font:normal normal 600 16px/28px Source Sans Pro!important}.addBtn[_ngcontent-%COMP%]{margin-top:21px}.btnRadio[_ngcontent-%COMP%]{height:15px;width:15px}.line-height-same-as-btn[_ngcontent-%COMP%]{line-height:43px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDutiesLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'job-duties-library',
                templateUrl: 'job-duties-library.component.html',
                styleUrls: ['job-duties-library.component.scss']
            }]
    }], function () { return [{ type: i1$1.DialogService }, { type: JobDutiesLibraryService }, { type: i3.ToastrService }, { type: i4.FormBuilder }]; }, { parentForm: [{
            type: Input
        }], inputData: [{
            type: Input
        }], deleteDuty: [{
            type: Output
        }], deleteAllDutie: [{
            type: Output
        }], deleteSubDuty: [{
            type: Output
        }], addUpdateDuty: [{
            type: Output
        }], onsaveJobRoleOrPopulateDuties: [{
            type: Output
        }], disabledControls: [{
            type: Input
        }] }); })();
class AddDutyComponent {
    constructor(dutiesFormBuilder, config, toastr, ref) {
        this.dutiesFormBuilder = dutiesFormBuilder;
        this.config = config;
        this.toastr = toastr;
        this.ref = ref;
        this.resetForm();
    }
    ngOnInit() {
        // Is it even used?
        // this.dutiesForm.patchValue(this.config.data.duties);
        // (this.dutiesForm.get('subJobDuty') as FormArray).clear();
        // this.config.data['duties'].subJobDuty.forEach((subDutyItem) => {
        //   (this.dutiesForm.get('subJobDuty') as FormArray).push(this.createSubDuty(subDutyItem));
        // });
    }
    createSubDuty(response) {
        return this.dutiesFormBuilder.group({
            id: response && response.id ? response.id : null,
            name: response && response.name ? response.name : null
        });
    }
    get subDutiesList() {
        return this.dutiesForm.get('subJobDuty').controls;
    }
    addSubDuty() {
        this.dutiesForm.get('subJobDuty').push(this.createSubDuty({}));
    }
    resetForm() {
        this.dutiesForm = this.dutiesFormBuilder.group({
            name: '',
            id: null,
            subJobDuty: this.dutiesFormBuilder.array([{
                    name: this.createSubDuty(null)
                }])
        });
    }
    handleClose() {
        this.ref.close();
    }
    appendDutyList() {
        this.ref.close({ type: this.config.data['type'], data: this.dutiesForm.value, dutyIndex: this.config.data['dutyIndex'] });
        this.toastr.success("Added Succesfully", 'Success');
    }
}
AddDutyComponent.ɵfac = function AddDutyComponent_Factory(t) { return new (t || AddDutyComponent)(i0.ɵɵdirectiveInject(i4.FormBuilder), i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i1$1.DynamicDialogRef)); };
AddDutyComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AddDutyComponent, selectors: [["add-duty-dialog"]], decls: 26, vars: 7, consts: [[1, "container", 3, "formGroup", "ngSubmit"], [1, "row", "mt-2"], ["for", "col-md-12 pl-0", 1, "mb-0", "control-lbl", "required"], [1, "col-md-12", "pl-0"], ["type", "textarea", "formControlName", "name", "required", "", 1, "im-input", "text-area", "duty-txt"], ["class", "invalid-message", 4, "ngIf"], [1, "mb-0", "control-lbl"], [1, "ml-3"], [3, "click"], [1, "col-md-12", "pl-0", 2, "max-height", "200px", "overflow-y", "auto"], ["formArrayName", "subJobDuty"], [4, "ngFor", "ngForOf"], [1, "row", "dasheedTopBorder", "mt-4", "pt-3", "pl-0"], [1, "col-md-12"], ["type", "submit", 1, "btn-success", "button-width-icon-left", "mr-3", 3, "ngClass", "disabled"], ["type", "button", 1, "btn", "btn-secondary", "button-width-icon-left", 3, "click"], [1, "invalid-message"], [1, "col-md-12", "row", "pl-0", "pr-0", "mt-2", 3, "formGroupName"], ["type", "textarea", "formControlName", "name", 1, "im-input", "text-area", "duty-txt"]], template: function AddDutyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵlistener("ngSubmit", function AddDutyComponent_Template_form_ngSubmit_0_listener() { return ctx.appendDutyList(); });
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵelementStart(2, "h5");
        i0.ɵɵtext(3, " Enter the list of duties required for this job");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 1);
        i0.ɵɵelementStart(5, "label", 2);
        i0.ɵɵtext(6, " Duty that the beneficiary will perform");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 3);
        i0.ɵɵelement(8, "textarea", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, AddDutyComponent_div_9_Template, 2, 0, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 1);
        i0.ɵɵelementStart(11, "div");
        i0.ɵɵelementStart(12, "label", 6);
        i0.ɵɵtext(13, " Sub Duties ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "span", 7);
        i0.ɵɵelementStart(15, "a", 8);
        i0.ɵɵlistener("click", function AddDutyComponent_Template_a_click_15_listener() { return ctx.addSubDuty(); });
        i0.ɵɵtext(16, " + New Sub Duty ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 9);
        i0.ɵɵelementStart(18, "div", 10);
        i0.ɵɵtemplate(19, AddDutyComponent_div_19_Template, 3, 1, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 12);
        i0.ɵɵelementStart(21, "div", 13);
        i0.ɵɵelementStart(22, "button", 14);
        i0.ɵɵtext(23, " Save ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "button", 15);
        i0.ɵɵlistener("click", function AddDutyComponent_Template_button_click_24_listener() { return ctx.handleClose(); });
        i0.ɵɵtext(25, " Close ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.dutiesForm);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.dutiesForm.get("name").touched && (ctx.dutiesForm.get("name").errors == null ? null : ctx.dutiesForm.get("name").errors.required));
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngForOf", ctx.subDutiesList);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3, ctx.dutiesForm.invalid))("disabled", ctx.dutiesForm.invalid);
    } }, directives: [i4.ɵangular_packages_forms_forms_ba, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.DefaultValueAccessor, i4.NgControlStatus, i4.FormControlName, i4.RequiredValidator, i6.NgIf, i4.FormArrayName, i6.NgForOf, i6.NgClass, i4.FormGroupName], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddDutyComponent, [{
        type: Component,
        args: [{
                selector: 'add-duty-dialog',
                templateUrl: 'new-duty.dialog.html'
            }]
    }], function () { return [{ type: i4.FormBuilder }, { type: i1$1.DynamicDialogConfig }, { type: i3.ToastrService }, { type: i1$1.DynamicDialogRef }]; }, null); })();

class JobDutiesLibraryModule {
}
JobDutiesLibraryModule.ɵfac = function JobDutiesLibraryModule_Factory(t) { return new (t || JobDutiesLibraryModule)(); };
JobDutiesLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: JobDutiesLibraryModule });
JobDutiesLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(JobDutiesLibraryModule, { declarations: [JobDutiesLibraryComponent, AddDutyComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        FormsModule,
        ReactiveFormsModule], exports: [JobDutiesLibraryComponent, AddDutyComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDutiesLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [JobDutiesLibraryComponent, AddDutyComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [JobDutiesLibraryComponent, AddDutyComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of job-duties-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddDutyComponent, JobDutiesLibraryComponent, JobDutiesLibraryModule, JobDutiesLibraryService };
//# sourceMappingURL=job-duties-library.js.map
